module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-long-7425ae07300b94f454f15c4d03dfedbd.jpg";